import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Trash } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import { getSellerCatalogCounts } from '@/redux/modules/seller/catalogCounts/sellerCatalogCounts.selectors';
import { getSellerName } from '@/redux/modules/seller/seller.selectors';
import { getSellerUrl } from '@/utils/urls';

import { TableRow } from './Components/TableRow';

type Props = {
    sellerId: number;
};

const FollowedSellerRow = ({ sellerId }: Props) => {
    const name = useAppSelector((state) => getSellerName(state, sellerId));
    const catalogCounts = useAppSelector((state) => getSellerCatalogCounts(state, sellerId));
    return (
        <TableRow
            email={
                <IconButton
                    icon={Trash}
                    size="sm"
                />
            }
            frequency={
                catalogCounts.upcomingCount === 0 ? <FormattedMessage id="no_upcoming" /> : catalogCounts.upcomingCount
            }
            key={name}
            sellerId={sellerId as number}
            type={<RouteLink to={getSellerUrl(sellerId, name)}>{name}</RouteLink>}
        />
    );
};

export default FollowedSellerRow;
